import {Component, OnInit} from '@angular/core';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-pricing-list',
  templateUrl: './pricing-list.component.html',
  styleUrls: ['./pricing-list.component.scss'],
  imports: [
    CommonModule,
    PageHeaderComponent,
    SelectDropDownModule,
    FormsModule,
  ]
})
export class PricingListComponent implements OnInit {

  public pricing_list: any =
    {
      customer_name: "",
      customer_id: "",
      date: new Date(),
      purchase_id: "",
      invoice_no: '',
      medicine_id: [""],
      unitprice: [""],
      sellingprice: [""],
      slab_a_per: [""],
      slab_a_amount: [""],
      slab_b_per: [""],
      slab_b_amount: [""],
      slab_c_per: [""],
      slab_c_amount: [""],
      user_id: '',
      vat: [""],
      flood: [""],
      slab_a_flood: [""],
      slab_b_flood: [""],
      slab_c_flood: [""],
      purchase_details_id: [""]

    }

  invoice: any = [""];
  item_list: any;
  user_rights: any;
  user_data: any;
  closeResult = "";
  discount_list: any;
  customer: any[] = [];
  status: any;
  customer_options: any[] = [];
  customer_data: any;
  print_data: any;
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");

  constructor(private loaderService: LoaderService,
              public rest: ReportService,
              public rest2: ConsultingService,
              protected utils: UtilsInjectable) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listCustomer();
    this.listAllItems();
  }

  public listCustomer() {
    this.customer = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listCustomer().subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.customer = result['data'];
        this.customer_options = this.customer;
        this.setCustomer();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public setCustomer() {
    if (this.pricing_list.customer_id) {
      for (let index = 0; index < this.customer.length; index++) {
        if (this.customer[index].CUSTOMER_ID == this.pricing_list.customer_id) {
          this.customer_data = this.customer[index];
          break;
        }
      }
    }
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  getCustomer() {
    this.pricing_list.customer_id = this.customer_data.CUSTOMER_ID;
    this.pricing_list.customer_name = this.customer_data.CUSTOMER_NAME;
    this.print();
  }

  public listAllItems() {

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest2.listAllItems().subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.discount_list = result['data'];
        this.addCheck();
        this.loaderService.display(false);
        this.print();

      } else {
        this.loaderService.display(false);
      }
    });
  }

  addCheck() {
    let i = 0;
    for (const data of this.discount_list) {
      data["CHECKED"] = true;
      data["A_CHECK"] = true;
      data["B_CHECK"] = false;
      data["C_CHECK"] = false;
      this.discount_list[i] = data;
      i = i + 1;
    }
    this.print();
  }

  updateChecked(_i: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        data.CHECKED = data.CHECKED == false;
      }
    }
  }

  updateAChecked(_: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.A_CHECK == false) {
          data.A_CHECK = true;
          data.B_CHECK = false;
          data.C_CHECK = false;
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  updateBChecked(_: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.B_CHECK == false) {
          data.A_CHECK = false;
          data.B_CHECK = true;
          data.C_CHECK = false;
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  updateCChecked(_: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.C_CHECK == false) {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = true;
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  public print() {
    const value: any = [];
    value["CUSTOMER_NAME"] = this.pricing_list.customer_name
    value["DATE"] = this.pricing_list.date
    this.print_data = this.discount_list.map((o: any): any => {
      if (o.CHECKED == true) {
        return {
          "TRADE_NAME": o.TRADE_NAME,
          "SLAB_A_AMOUNT": o.SLAB_A_AMOUNT,
          "SLAB_B_AMOUNT": o.SLAB_B_AMOUNT,
          "SLAB_C_AMOUNT": o.SLAB_C_AMOUNT,
          "A_CHECK": o.A_CHECK,
          "B_CHECK": o.B_CHECK,
          "C_CHECK": o.C_CHECK,
        };
      }

    });
    this.print_data.push(value);
  }

}
